import React from "react";

import {
Document,
Page,
Text,
View,
Image,
StyleSheet,
} from "@react-pdf/renderer";

import schoolLogo from "./savationChristLogo.png";

const styles = StyleSheet.create({


page: {

    padding: 18,

    backgroundColor: "#ffffff",

    fontFamily: "Helvetica",

},


receiptContainer: {

    border: "1px solid #222",

    padding: 9,

    height: 355,

    flexShrink: 0,

},


header: {

    flexDirection: "row",

    alignItems: "center",

    borderBottom: "1px solid #222",

    paddingBottom: 6,

    marginBottom: 6,

},


logo: {

    width: 45,

    height: 45,

    objectFit: "contain",

    marginRight: 8,

},


schoolInfo: {

    flex: 1,

},


schoolName: {

    fontSize: 13,

    fontWeight: "bold",

    marginBottom: 2,

    textTransform: "uppercase",

},


contactText: {

    fontSize: 7,

    marginBottom: 1,

    color: "#333333",

},


receiptTitle: {

    textAlign: "center",

    fontSize: 11,

    fontWeight: "bold",

    marginBottom: 4,

    textTransform: "uppercase",

    letterSpacing: 0.5,

},


copyLabel: {

    alignSelf: "center",

    border: "1px solid #333",

    paddingVertical: 2,

    paddingHorizontal: 8,

    fontSize: 6.5,

    fontWeight: "bold",

    marginBottom: 5,

    textTransform: "uppercase",

},


receiptMeta: {

    flexDirection: "row",

    justifyContent: "space-between",

    marginBottom: 5,

},


metaColumn: {

    width: "48%",

},


metaRow: {

    flexDirection: "row",

    marginBottom: 2,

},


metaLabel: {

    width: 70,

    fontSize: 7,

    fontWeight: "bold",

},


metaValue: {

    flex: 1,

    fontSize: 7,

},


table: {

    width: "100%",

    border: "1px solid #333",

    marginTop: 4,

},


tableHeader: {

    flexDirection: "row",

    backgroundColor: "#eeeeee",

    borderBottom: "1px solid #333",

    paddingVertical: 3,

    paddingHorizontal: 4,

},


tableRow: {

    flexDirection: "row",

    borderBottom: "1px solid #dddddd",

    paddingVertical: 3,

    paddingHorizontal: 4,

},


tableCell: {

    fontSize: 7,

},


descriptionColumn: {

    width: "50%",

},


amountColumn: {

    width: "25%",

    textAlign: "right",

},


statusColumn: {

    width: "25%",

    textAlign: "right",

},


summary: {

    marginTop: 5,

    marginLeft: "50%",

    width: "50%",

},


summaryRow: {

    flexDirection: "row",

    justifyContent: "space-between",

    paddingVertical: 2,

    borderBottom: "1px solid #dddddd",

},


summaryLabel: {

    fontSize: 7.5,

    fontWeight: "bold",

},


summaryValue: {

    fontSize: 7.5,

},


balanceRow: {

    flexDirection: "row",

    justifyContent: "space-between",

    paddingVertical: 3,

    marginTop: 2,

    backgroundColor: "#eeeeee",

    paddingHorizontal: 4,

},


balanceLabel: {

    fontSize: 8,

    fontWeight: "bold",

},


balanceValue: {

    fontSize: 8,

    fontWeight: "bold",

},


footer: {

    flexDirection: "row",

    justifyContent: "space-between",

    marginTop: 9,

},


signatureBox: {

    width: "42%",

    borderTop: "1px solid #333",

    paddingTop: 3,

},


signatureText: {

    fontSize: 6.5,

    textAlign: "center",

},


note: {

    marginTop: 5,

    fontSize: 6,

    color: "#555555",

    textAlign: "center",

},


separator: {

    borderTop: "1px dashed #555",

    marginVertical: 8,

},


});

const formatAmount = value => {


return Number(

    value || 0

).toFixed(2);


};

const capitalize = value => {


if (!value) {

    return "N/A";

}

return value.charAt(0).toUpperCase()

    + value.slice(1);


};

const PaymentReceipt = ({


payment,

paymentHistory,

copyType,


}) => {


const totalPaid = paymentHistory.reduce(

    (total, item) =>

        total +

        Number(

            item.amount_paid || 0

        ),

    0

);


const totalAmount = paymentHistory.reduce(

    (total, item) =>

        total +

        Number(

            item.total_amount || 0

        ),

    0

);


const totalBalance = Math.max(

    totalAmount - totalPaid,

    0

);


return (

    <View

        style={styles.receiptContainer}

        wrap={false}

    >

        <View style={styles.header}>

            <Image

                src={schoolLogo}

                style={styles.logo}

            />


            <View style={styles.schoolInfo}>

                <Text style={styles.schoolName}>

                    Jana L. Williams Educational Foundation 
                    
                    

                </Text>


                <Text style={styles.contactText}>
                   Mt. Barclay New Store Community
                 
                </Text>


                <Text style={styles.contactText}>

                    Contact: +231-776-494-010 / +231-880-585-855 / +231-770-540-258

                </Text>


                <Text style={styles.contactText}>

                    Email: salvationinchristschoolsystem@gmail.com

                </Text>

            </View>

        </View>


        <Text style={styles.receiptTitle}>

            Other Fees Payment Receipt

        </Text>


        <Text style={styles.copyLabel}>

            {copyType}

        </Text>


        <View style={styles.receiptMeta}>

            <View style={styles.metaColumn}>

                <View style={styles.metaRow}>

                    <Text style={styles.metaLabel}>

                        Receipt No:

                    </Text>


                    <Text style={styles.metaValue}>

                        OFP-{payment.id}

                    </Text>

                </View>


                <View style={styles.metaRow}>

                    <Text style={styles.metaLabel}>

                        Payer:

                    </Text>


                    <Text style={styles.metaValue}>

                        {payment.payer_name || "N/A"}

                    </Text>

                </View>


                <View style={styles.metaRow}>

                    <Text style={styles.metaLabel}>

                        Student:

                    </Text>


                    <Text style={styles.metaValue}>

                        {payment.student_name || "Manual Payer"}

                    </Text>

                </View>

            </View>


            <View style={styles.metaColumn}>

                <View style={styles.metaRow}>

                    <Text style={styles.metaLabel}>

                        Academic Year:

                    </Text>


                    <Text style={styles.metaValue}>

                        {payment.academic_year_name || "N/A"}

                    </Text>

                </View>


                <View style={styles.metaRow}>

                    <Text style={styles.metaLabel}>

                        Class:

                    </Text>


                    <Text style={styles.metaValue}>

                        {payment.student_class_name || "N/A"}

                    </Text>

                </View>


                <View style={styles.metaRow}>

                    <Text style={styles.metaLabel}>

                        Date:

                    </Text>


                    <Text style={styles.metaValue}>

                        {payment.date || "N/A"}

                    </Text>

                </View>

            </View>

        </View>


        <View style={styles.table}>

            <View style={styles.tableHeader}>

                <Text

                    style={[

                        styles.tableCell,

                        styles.descriptionColumn,

                    ]}

                >

                    PAYMENT DESCRIPTION

                </Text>


                <Text

                    style={[

                        styles.tableCell,

                        styles.amountColumn,

                    ]}

                >

                    AMOUNT

                </Text>


                <Text

                    style={[

                        styles.tableCell,

                        styles.statusColumn,

                    ]}

                >

                    MONTH

                </Text>

            </View>


            {paymentHistory.map(

                item => (

                    <View

                        key={item.id}

                        style={styles.tableRow}

                    >

                        <Text

                            style={[

                                styles.tableCell,

                                styles.descriptionColumn,

                            ]}

                        >

                            {item.fee_type_name}

                        </Text>


                        <Text

                            style={[

                                styles.tableCell,

                                styles.amountColumn,

                            ]}

                        >

                            {formatAmount(

                                item.amount_paid

                            )}

                        </Text>


                        <Text

                            style={[

                                styles.tableCell,

                                styles.statusColumn,

                            ]}

                        >

                            {capitalize(

                                item.month

                            )}

                        </Text>

                    </View>

                )

            )}

        </View>


        <View style={styles.summary}>

            <View style={styles.summaryRow}>

                <Text style={styles.summaryLabel}>

                    Total Amount:

                </Text>


                <Text style={styles.summaryValue}>

                    {formatAmount(

                        totalAmount

                    )}

                </Text>

            </View>


            <View style={styles.summaryRow}>

                <Text style={styles.summaryLabel}>

                    Total Paid:

                </Text>


                <Text style={styles.summaryValue}>

                    {formatAmount(

                        totalPaid

                    )}

                </Text>

            </View>


            <View style={styles.balanceRow}>

                <Text style={styles.balanceLabel}>

                    BALANCE:

                </Text>


                <Text style={styles.balanceValue}>

                    {formatAmount(

                        totalBalance

                    )}

                </Text>

            </View>

        </View>


        <View style={styles.footer}>

            <View style={styles.signatureBox}>

                <Text style={styles.signatureText}>

                    Payer's Signature

                </Text>

            </View>


            <View style={styles.signatureBox}>

                <Text style={styles.signatureText}>

                    Authorized Signature

                </Text>

            </View>

        </View>


        <Text style={styles.note}>

            This receipt is computer generated and is valid

            without a physical stamp. - Polu Integrated School Management System

        </Text>

    </View>

);


};

const OtherFeePaymentRecieptPDF = ({


payment,

paymentHistory,


}) => {


return (

    <Document>

        <Page

            size="A4"

            style={styles.page}

            wrap={false}

        >

            <PaymentReceipt

                payment={payment}

                paymentHistory={paymentHistory}

                copyType="PAYER COPY"

            />


            <View style={styles.separator} />


            <PaymentReceipt

                payment={payment}

                paymentHistory={paymentHistory}

                copyType="ADMINISTRATION COPY"

            />

        </Page>

    </Document>

);


};

export default OtherFeePaymentRecieptPDF;
